<script lang="ts">
  export type RoundResultVariant = 'score' | 'song';
</script>
<script lang="ts" setup>
  defineProps<{ variant: RoundResultVariant }>();
</script>

<template>
  <header class="results-header">
    <span class="header-placement">#</span>
    <span class="header-player">Player</span>
    <div class="header-value">
      <span :data-shown="variant === 'score'" class="variant">Score</span>
      <span class="separator">/</span>
      <span :data-shown="variant === 'song'" class="variant">Song</span>
    </div>
  </header>
</template>

<style scoped>
  .results-header {
    align-items: center;
    border-bottom: 1px solid var(--color-border-translucent);
    color: var(--color-text-secondary);
    display: grid;
    font-size: var(--font-size-xs);
    gap: 0.5rem;
    grid-template-columns: var(--placement-width) minmax(0, 1fr) auto;
    letter-spacing: 0.05rem;
    padding: 0.4rem var(--row-inset);
    text-align: left;
    text-transform: uppercase;
  }

  .header-value {
    align-items: center;
    display: flex;
    gap: 0.25rem;
    text-align: right;
  }

  .variant {
    color: var(--color-text-muted);
    font-weight: var(--font-weight-body);
    transition: all 0.2s;
  }

  .variant[data-shown='true'] {
    color: var(--color-primary);
    font-weight: var(--font-weight-strong);
  }

  .separator {
    color: var(--color-border-strong);
  }
</style>
